







import Vue from 'vue';
export default Vue.extend({
  name: 'PairingProgressIndicator',
  props: {
    progressStep: {
      type: Number,
      required: true,
      default: 1,
    },
  },
  computed: {
    deg(): number {
      switch (this.$props.progressStep) {
        case 1:
          return 90;
        case 2:
          return 180;
        case 3:
          return 270;
        case 4:
          return 360;
      }
      return 0;
    },
    wrapperClipped(): boolean {
      return this.$props.progressStep <= 2;
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PairingProgressIndicator.vue